import hatsApi from '@/services/hatsApi'

export default {
  getPriceProviders () {
    return hatsApi().get('/master-data/price-provider')
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/PriceProvider.js